import React from 'react';
import { L } from './estilos';

const CIFRAS = [
  ['total', 'Destinatarios'],
  ['enviados', 'Enviados'],
  ['entregados', 'Entregados'],
  ['leidos', 'Leídos'],
  ['respondidos', 'Respondidos'],
  ['fallidos', 'Fallidos'],
];

/**
 * Barra de procesados sobre el total y los cinco contadores de §10: en una
 * línea en el listado y como cifras en el detalle.
 */
const Progreso = ({ campana, detallado = false }) => {
  const procesados = campana.enviados + campana.fallidos + campana.desconocidos;
  const porcentaje = campana.total > 0 ? Math.round((procesados * 100) / campana.total) : 0;
  return (
    <div className="campanas-progreso" style={L.progreso}>
      <div style={L.barraFila}>
        <div style={L.barra}><div style={L.relleno(porcentaje)} /></div>
        <span style={L.porcentaje}>{`${porcentaje} %`}</span>
      </div>
      {detallado ? (
        <div style={L.cifras}>
          {CIFRAS.map(([clave, etiqueta]) => (
            <div key={clave} style={L.cifra}>
              <div style={L.cifraValor}>{campana[clave]}</div>
              <div style={L.cifraEtiqueta}>{etiqueta}</div>
            </div>
          ))}
        </div>
      ) : (
        <span className="campanas-texto" style={L.contadores}>
          {`Enviados ${campana.enviados} · Entregados ${campana.entregados} · Leídos ${campana.leidos} · `
            + `Respondidos ${campana.respondidos} · Fallidos ${campana.fallidos} de ${campana.total}`}
        </span>
      )}
    </div>
  );
};

export default Progreso;
